// Autogenerated by util/sync-labels/sync-labels.ts
// Do not edit this file directly.
// To regenerate this file, start ithriv_landing_service locally on port 8000 and
// run the following command in the root directory of the ithriv_web repository:
// > npm run sync_labels
import {LabelResponse} from '@backend';

export enum PublicLicense {
  CC0_1_0 = 'cc0-1.0',
  CC_BY_4_0 = 'cc-by-4.0',
  CC_BY_SA_4_0 = 'cc-by-sa-4.0',
  CC_BY_NC_4_0 = 'cc-by-nc-4.0',
  CC_BY_NC_SA_4_0 = 'cc-by-nc-sa-4.0',
  CC_BY_ND_4_0 = 'cc-by-nd-4.0',
  CC_BY_NC_ND_4_0 = 'cc-by-nc-nd-4.0',
}

export const PublicLicenseLabels = {
  'cc0-1.0': 'CC0 1.0',
  'cc-by-4.0': 'CC BY 4.0',
  'cc-by-sa-4.0': 'CC BY-SA 4.0',
  'cc-by-nc-4.0': 'CC BY-NC 4.0',
  'cc-by-nc-sa-4.0': 'CC BY-NC-SA 4.0',
  'cc-by-nd-4.0': 'CC BY-ND 4.0',
  'cc-by-nc-nd-4.0': 'CC BY-NC-ND 4.0',
} as const;

export type PublicLicenseId = keyof typeof PublicLicenseLabels;
export type PublicLicenseLabel = (typeof PublicLicenseLabels)[PublicLicenseId];

export const PublicLicenseOptions: Record<PublicLicense, LabelResponse> = {
  'cc0-1.0': {
    id: PublicLicense.CC0_1_0,
    text: PublicLicenseLabels[PublicLicense.CC0_1_0],
    sensitivity_level_id: null,
    display_order: 1,
  },
  'cc-by-4.0': {
    id: PublicLicense.CC_BY_4_0,
    text: PublicLicenseLabels[PublicLicense.CC_BY_4_0],
    sensitivity_level_id: null,
    display_order: 2,
  },
  'cc-by-sa-4.0': {
    id: PublicLicense.CC_BY_SA_4_0,
    text: PublicLicenseLabels[PublicLicense.CC_BY_SA_4_0],
    sensitivity_level_id: null,
    display_order: 3,
  },
  'cc-by-nc-4.0': {
    id: PublicLicense.CC_BY_NC_4_0,
    text: PublicLicenseLabels[PublicLicense.CC_BY_NC_4_0],
    sensitivity_level_id: null,
    display_order: 4,
  },
  'cc-by-nc-sa-4.0': {
    id: PublicLicense.CC_BY_NC_SA_4_0,
    text: PublicLicenseLabels[PublicLicense.CC_BY_NC_SA_4_0],
    sensitivity_level_id: null,
    display_order: 5,
  },
  'cc-by-nd-4.0': {
    id: PublicLicense.CC_BY_ND_4_0,
    text: PublicLicenseLabels[PublicLicense.CC_BY_ND_4_0],
    sensitivity_level_id: null,
    display_order: 6,
  },
  'cc-by-nc-nd-4.0': {
    id: PublicLicense.CC_BY_NC_ND_4_0,
    text: PublicLicenseLabels[PublicLicense.CC_BY_NC_ND_4_0],
    sensitivity_level_id: null,
    display_order: 7,
  },
} as const;
